export default "__VITE_ASSET__iMEq_gvf__"